import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { redirectTo } from 'actions/core/navigation'
import LoadingState from 'components/core/loading_state'
import { PageContent } from 'components/page_elements'

import { useFetchCalendarAccountsQuery } from '../api'

const Content = withSafeSuspense(lazy(async () => ({ default: (await import('./content')).Content })))

export const Accounts = () => {
  // if user has an unconfigured outlook desktop account, then redirect to /outlook_desktop/:id/edit
  const dispatch = useDispatch()
  const { url } = useRouteMatch()
  const { data, isFetching } = useFetchCalendarAccountsQuery()

  const unconfiguredOutlookDesktopAccount = !!data && Object.values(data.entities || {}).find(
    ({ kind, outlookDesktopConfigured }) => !outlookDesktopConfigured && kind === 'outlook_desktop'
  )

  if (isFetching) return <LoadingState />

  if (unconfiguredOutlookDesktopAccount?.uuid) {
    dispatch(
      redirectTo(`${url}/outlook_desktop/${unconfiguredOutlookDesktopAccount.uuid}/edit`)
    )
    return null
  }

  return (
    <PageContent>
      <Content />
    </PageContent>
  )
}
